import { useState } from 'react';

export default function AppSection() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 p-8 md:p-12 lg:p-14">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
                iOS · Android 即将上线
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                APP下载
              </h2>
              <p className="text-sm md:text-base text-background-50/85 leading-relaxed max-w-[480px] mx-auto lg:mx-0 mb-6">
                香蕉漫画移动客户端即将推出，专为手机阅读优化，支持离线缓存、夜间模式、个性化推荐等丰富功能。敬请期待更沉浸式的漫画阅读体验。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 rounded-full font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-notification-3-line"></i>
                  上线通知
                </a>
                <span className="text-xs text-background-50/60 whitespace-nowrap">
                  敬请期待更多精彩
                </span>
              </div>
            </div>

            <div className="flex-shrink-0 w-full max-w-[320px] lg:max-w-[360px]">
              {!imgError ? (
                <div className="relative rounded-xl overflow-hidden bg-background-50/10 aspect-[9/16] max-h-[420px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20manga%20reading%20app%20interface%20with%20colorful%20comic%20thumbnails%20and%20clean%20UI%20design%2C%20warm%20orange%20and%20cream%20theme%20colors%2C%20floating%20phone%20on%20soft%20gradient%20background%2C%20minimalist%20product%20presentation%20style%2C%20professional%20app%20showcase%20photography%20with%20gentle%20lighting%20and%20refined%20composition&width=720&height=1280&seq=app-mockup-manga-01&orientation=portrait"
                    alt="香蕉漫画 APP 移动端界面预览"
                    className="w-full h-full object-cover"
                    onError={() => setImgError(true)}
                  />
                </div>
              ) : (
                <div className="relative rounded-xl overflow-hidden bg-background-50/10 aspect-[9/16] max-h-[420px] flex items-center justify-center">
                  <i className="ri-smartphone-line text-5xl text-background-50/40"></i>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}